<template>
  <div class="search-websites d-flex flex-column">
    <div class="label">Selecteer winkel</div>
    <div class="input-wrapper d-flex flex-column" ref="dropdown-list">
      <input
        class="input"
        id="website-search"
        v-model.trim="search"
        placeholder="Zoek winkel..."
      />

      <div style="position: relative; flex-basis: 100%">
        <div style="position: absolute; width: 100%; height: 100%">
          <InfiniteScrolling
            v-if="!loading && nonIncludedWebsites.length"
            ref="scroller"
            class="InfiniteScrolling"
            :searchMore="searchMore"
            :show-end="showEnd"
          >
            <WebsiteItem
              v-for="(item, i) in nonIncludedWebsites"
              :key="item.uid"
              v-bind="item"
              class="product-group-option"
              @click.native="selectWebsite(item)"
            />
          </InfiniteScrolling>
          <div v-else-if="!nonIncludedWebsites.length">
            <h3>Geen winkel beschikbaar</h3>
          </div>
          <div v-else>
            <div v-for="(site, i) in placeholder" :key="site.uid + i">
              <WebsiteItem v-bind="site" :ske="true" class="placeholder-item" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteScrolling from "src/layout/InfiniteScrolling.vue";
import WebsiteItem from "./WebsiteItem.vue";

const placeholder = {
  uid: 1,
  domainname: "ashtashtashtast.@asheti.cmo",
};

export default {
  props: {
    selected: Array,
  },
  components: {
    InfiniteScrolling,
    WebsiteItem,
  },
  data() {
    return {
      websites: [],
      search: "",
      offset: 0,
      showEnd: true,
      loading: false,

      placeholder: [
        placeholder,
        placeholder,
        placeholder,
        placeholder,
        placeholder,
        placeholder,
        placeholder,
        placeholder,
        placeholder,
      ],
    };
  },
  async created() {
    this.loading = true;
    await this.searchMore();
    this.loading = false;

    this.showEnd = this.websites.length >= 10;
  },
  methods: {
    selectWebsite(site) {
      this.$emit("select-website", site);
    },

    async searchMore(observed) {
      if (observed && !this.deepSearching) return;

      this.deepSearching = true;
      this.offset++;

      const moreItems = await this.request();
      if (!moreItems.length) return true;

      this.websites.push(...moreItems);
      return moreItems.length < 10;
    },
    async request(page = this.offset) {
      const { data } = await this.axios.get("/api/websites", {
        params: {
          search: this.search,
          page,
        },
      });

      return data.results;
    },
  },
  computed: {
    nonIncludedWebsites() {
      const selected = this.selected;
      return this.websites.filter(
        ({ uid }) => !selected.some((item) => uid === item.uid)
      );
    },
  },
};
</script>

<style scoped>
.search-websites {
  flex-basis: 100%;
}

.input-wrapper {
  flex-basis: 100%;
}

.InfiniteScrolling {
  height: 100%;
  overflow: auto;
}

.input-wrapper {
  position: relative;
  border: 1px solid #e3e3e3;
  border-radius: 1px;
  z-index: 15;
  overflow: hidden;
}

.input {
  padding: 4px 10px;
  border-bottom: 1px solid #e3e3e3;
  width: 100%;
}

.label {
  margin-bottom: 8px;
}

.placeholder-item {
  width: 100%;
  margin-top: 8px;
}

h3 {
  text-align: center;
  font-size: 1.25em;
  margin-bottom: 20px;
  color: #717272;
}
</style>
